const filter = (value, onlyNumber: Boolean): string => {
  if (!value) {
    return ''
  }

  return onlyNumber
    ? value.replace(/^\d*(\d{4})$/, 'Final $1')
    : value.replace(/(Código do Cartão =) \d*(\d{4})/, '$1 Final $2')
}

export default filter
